const getHostSummaryResponse = (response) => {
  let liveOverview = response?.liveOverview ?? {};
  let salesOverview = response?.salesOverview ?? {};

  const achievement = {
    rankPosition: response?.rank?.rank || null,
    brandRevenue: {
      target: response?.brandAchievement?.targetGmv ?? 0,
      progress: response?.brandAchievement?.actualGmv ?? 0,
      progressPercentage: response?.brandAchievement?.achievementGmvPercentage ?? 0,
      isCurrency: true,
    },
    ctr: {
      target: response?.brandAchievement?.targetCtr ?? 0,
      progress: response?.brandAchievement?.actualCtr ?? 0,
      progressPercentage: response?.brandAchievement?.achievementCtrPercentage ?? 0,
      uom: '%',
      uomPosition: 'right',
    },
    ctor: {
      target: response?.brandAchievement?.targetCtor ?? 0,
      progress: response?.brandAchievement?.actualCtor ?? 0,
      progressPercentage: response?.brandAchievement?.achievementCtorPercentage ?? 0,
      uom: '%',
      uomPosition: 'right',
    },
    err: {
      target: response?.brandAchievement?.targetErr ?? 0,
      progress: response?.brandAchievement?.actualErr ?? 0,
      progressPercentage: response?.brandAchievement?.achievementErrPercentage ?? 0,
      uom: '%',
      uomPosition: 'right',
    },
    aov: {
      target: response?.brandAchievement?.targetAov ?? 0,
      progress: response?.brandAchievement?.actualAov ?? 0,
      progressPercentage: response?.brandAchievement?.achievementAovPercentage ?? 0,
      isCurrency: true,
    },
  };

  liveOverview = {
    finished: liveOverview?.finished ?? 0,
    upcoming: liveOverview?.upcoming ?? 0,
    total: liveOverview?.total ?? 0,
    duration: liveOverview?.duration ?? 0,
    targetDuration: liveOverview?.targetDuration ?? 0,
    durationPercentage: liveOverview?.durationPercentage ?? 0,
  };

  salesOverview = {
    sales: salesOverview?.sales ?? 0,
    targetSales: salesOverview?.targetSales ?? 0,
    growthPercentage: salesOverview?.growthPercentage ?? 0,
    salesPercentage: salesOverview?.salesPercentage ?? 0,
    buyer: salesOverview?.buyer ?? 0,
    viewer: salesOverview?.viewer ?? 0,
    avgSalesPerLive: salesOverview?.avgSalesPerLive ?? 0,
    avgConversionRate: salesOverview?.avgConversionRate ?? 0,
  };

  const result = { liveOverview, salesOverview, achievement };

  return result;
};

export default getHostSummaryResponse;
